var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WsTag',{ref:"refWsNotifyTag",attrs:{"url":_vm.wsUrl},on:{"wsOnMessage":_vm.wsOnMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }